import React, { useEffect, useState } from 'react';
// Components
import { Text, HStack } from 'native-base';

// Helpers
import { timeFrom } from '@breakroom-nx/helpers';

// Assets
import { theme } from '@breakroom-nx/assets';
import { ClockIcon, FireIcon } from 'react-native-heroicons/solid';
import { Streak } from '@breakroom-nx/classes';

export interface ChatStreakProps {
  created: Date;
  expires: Date;
  streak: Streak;
  verbose?: boolean;
}

export function ChatStreak({
  created,
  expires,
  streak,
  verbose = false,
}: ChatStreakProps) {
  // State to trigger re-render every minute
  const [, setTimeLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((tick) => tick + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <HStack
      space={2}
      alignItems={'center'}
      direction={'row'}
      pl={verbose ? 2 : 0}
      pr={verbose ? 3 : 0}
      py={verbose ? 1 : 0}
      rounded={'full'}
      bg={verbose ? 'surface.400' : 'none'}
      maxWidth={'full'}
    >
      <HStack space={1} alignItems={'center'}>
        <FireIcon size={16} color={theme.colors.orange[300]} />
        <Text color={theme.colors.orange[300]} fontSize={15} fontWeight={600}>
          {`${timeFrom(created)}` + (verbose ? ' Streak' : '')}
        </Text>
      </HStack>
      <HStack space={1} alignItems={'center'}>
        <ClockIcon size={16} color={streak?.getColor()} />
        <Text color={streak?.getColor()} fontSize={15} fontWeight={600}>
          {`${timeFrom(expires, false, false, true, true)}` +
            (verbose ? ' Left' : '')}
        </Text>
      </HStack>
    </HStack>
  );
}

export default ChatStreak;
